<div class="giphy-container">
    <div class="giphy-search">
        <input
            id="giphy-search"
            class="search form-control"
            type="search"
            placeholder="{{ 'Search for a GIF' | translate }}"
            aria-label="Search"
            [(ngModel)]="searchQuery"
            (ngModelChange)="searchQueryUpdate.next($event)"
            name="search"
            autocomplete="off" />
        <div class="mt-1 text-end">
            <img src="sb-tools/theme/images/PoweredByGiphy.png" alt="PoweredByGiphy" height="12px" />
        </div>
    </div>
    <div class="giphy-results-container">
        <ul
            class="giphy-results"
            infiniteScroll
            [infiniteScrollDistance]="1"
            [infiniteScrollThrottle]="50"
            (scrolled)="loadMore()"
            [infiniteScrollContainer]="'.giphy-results-container'"
            [fromRoot]="true">
            @for (result of giphyResults; track result) {
                <li class="giphy-result">
                    <img src="{{ result.images.downsized_large.url }}" (click)="sendGif(result.images.original)" />
                </li>
            }
            @if (!isLoadingGifs && !giphyResults.length) {
                <div class="text-center">{{ 'No results found' | translate }}</div>
            }
        </ul>
        @if (isLoadingGifs) {
            <sb-loader></sb-loader>
        }
    </div>
</div>
